import { Map } from 'immutable';

import Api from '../api';

import AutoSourcingRule from './model';
import { addMultipleAction, updateAction, addAction } from './types';

export default class AutoSourcingRulesApi {
  static fetchAll() {
    return Api.get('api/deed/autoSourcingRules').map((rules: AutoSourcingRule[]) =>
      addMultipleAction(
        Map(rules.map((rule: AutoSourcingRule) => [rule.id, new AutoSourcingRule(rule)]))
      )
    );
  }

  static update(id: string, data: AutoSourcingRule) {
    return Api.patch(`api/deed/autoSourcingRules/${id}`, data).map((autoSourcingRule) =>
      updateAction(new AutoSourcingRule(autoSourcingRule))
    );
  }

  static create(data: AutoSourcingRule) {
    return Api.post('api/deed/autoSourcingRules', data).map((autoSourcingRule) =>
      addAction(new AutoSourcingRule(autoSourcingRule))
    );
  }
}
